import React from 'react';
import PropTypes from 'prop-types';
import { AppBar as MUIAppBar, Toolbar, Typography, Avatar, IconButton, Box, Stack } from '@mui/material';
import { Logout as LogoutIcon } from '@mui/icons-material';
import useAuth from '../hooks/useAuth';

const AppBar = ({ username, setAuth, role }) => {
  const { position, userImage } = useAuth();

  const handleLogout = () => {
    setAuth(false);
  };

  return (
    <MUIAppBar position="fixed" elevation={0} sx={styles.appBar}>
      <Toolbar sx={styles.toolbar}>
        <Typography variant="h6" noWrap sx={styles.title}>
          TVRI SuperApps
        </Typography>
        <Box sx={styles.userInfo}>
          <Stack sx={{ display: { xs: 'none', sm: 'flex' } }}>
            <Typography noWrap sx={styles.username}>{username}</Typography>
            <Typography fontWeight="bold" fontSize={12} textAlign="right" noWrap sx={styles.position}>{position}</Typography>
          </Stack>
          {userImage ? (
            <Avatar alt={username} src={userImage} sx={styles.avatar} />
          ) : (
            <Avatar alt={username} sx={styles.avatar}>{username.charAt(0)}</Avatar>
          )}
          <IconButton color="inherit" onClick={handleLogout} sx={styles.logoutButton}>
            <LogoutIcon />
          </IconButton>
        </Box>
      </Toolbar>
    </MUIAppBar>
  );
};

const styles = {
  appBar: {
    backgroundColor: '#ffffff',
    color: 'var(--text-primary)',
    boxShadow: '0 8px 24px rgba(15,23,42,0.08)',
    borderBottom: '1px solid var(--border-subtle)',
    width: '100%',
    maxWidth: '100vw',
    left: 0,
    right: 0,
  },
  toolbar: {
    minHeight: { xs: 56, sm: 64 },
    px: { xs: 2, sm: 3 },
    pl: { xs: 7, sm: 3 },
    width: '100%',
    maxWidth: '100%',
  },
  title: {
    flexGrow: 1,
    fontWeight: 700,
    fontSize: { xs: '1.1rem', sm: '1.25rem' },
  },
  userInfo: {
    display: 'flex',
    alignItems: 'center',
    gap: { xs: 0.5, sm: 1 },
  },
  username: {
    marginLeft: 2,
  },
  position: {
    marginLeft: 2,
    color: 'var(--text-secondary)',
  },
  avatar: {
    marginLeft: { xs: 0, sm: 2 },
    width: { xs: 36, sm: 40 },
    height: { xs: 36, sm: 40 },
    backgroundColor: '#e0f2f1',
    color: '#0f8a3d',
  },
  logoutButton: {
    marginLeft: { xs: 0.5, sm: 2 },
    backgroundColor: '#f8fafc',
    border: '1px solid var(--border-subtle)',
    padding: { xs: 1, sm: 1.5 },
    '&:hover': {
      backgroundColor: '#eef2ff',
    },
  },
};

AppBar.propTypes = {
  username: PropTypes.string.isRequired,
  setAuth: PropTypes.func.isRequired,
  role: PropTypes.array,
};

export default AppBar;
